import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

export function Cross(props: Props) {
  const colorValue = props.stroke ?? (props.sx as any)?.color ?? "#F07C29";
  return (
    <SvgIcon {...props} sx={{ ...props.sx, color: colorValue }}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </SvgIcon>
  )
}
